import moment from 'moment'

const _compare = (a, b) => {
  if (a.created < b.created) {
    return -1
  }
  if (a.created > b.created) {
    return 1
  }
  return 0
}

const _getListStaticTime = (room, settings) => {
  /*
    This is for old computers that are too slow to display elapsed time
    updated every second.
  */
  let value
  if (room.status === 'running') {
    value = moment.unix(room.last_running).format(
      settings.date.longdatetimeFormat)
  } else if (['waiting', 'transferred'].indexOf(room.status) > -1) {
    value = moment.unix(room.last_waiting).format(
      settings.date.longdatetimeFormat)
  } else if (room.status === 'late') {
    value = moment.unix(room.last_waiting).format(
      settings.date.longdatetimeFormat)
  } else if (room.status === 'closed') {
    value = moment.unix(room.last_closed).format(settings.date.datetimeFormat)
  }

  return value
}

const _getListTime = (startTime, room) => {
  /* We don't use momentjs here as it consumes too much memory */
  let value
  if (room.status === 'running') {
    value = startTime - room.last_running * 1000
  } else if (['waiting', 'transferred'].indexOf(room.status) > -1) {
    value = startTime - room.last_waiting * 1000
  } else if (room.status === 'late') {
    value = startTime - room.last_waiting * 1000
  } else if (room.status === 'closed') {
    value = room.last_closed * 1000 - room.last_running * 1000
  }
  value = new Date(value).toLocaleTimeString('en-GB', {
    timeZone: 'UTC'
  })
  return value
}

// initial state
const state = {
  areTimersStarted: false,
  startTime: +new Date(),
  areRoomsLoading: true,
  isRoomLoading: true,
  list: null,
  messages: null,
  notes: null,
  openRoomsCount: 0,
  room: null,
  history: null,
  zencallSkills: null
}

// getters
const getters = {
  areRoomsLoading () {
    return state.areRoomsLoading
  },
  getAll () {
    return state.list
  },
  getEventFromHistory: (state) => (eventUuid) => {
    let event = null
    if (state.history) {
      state.history.forEach((evt) => {
        if (evt.uuid === eventUuid) {
          event = evt
        }
      })
    }
    return event
  },
  getOpenRoomsCount: (state) => {
    return state.openRoomsCount
  },
  getRoom () {
    return state.room
  },
  getRoomMessages () {
    if (state.messages !== null) {
      const messages = JSON.parse(JSON.stringify(state.messages))
      return messages.sort(_compare)
    }
    return []
  },
  getRoomStatus () {
    let status = ''
    if (state.room !== null) {
      status = state.room.status
    }
    return status
  },
  getRoomHistory () {
    let history = ''
    if (state.history !== null) {
      history = state.history
    }
    return history
  },
  getRoomNotes () {
    let notes = ''
    if (state.notes !== null) {
      notes = state.notes
    }
    return notes
  },
  getRoomUserInfos () {
    let details = {
      name: '',
      language: '',
      device: '',
      browser: '',
      active_since: '',
      origin: '',
      skill: '',
      extra: '',
      phone_number: '',
      satisfaction: ''
    }
    if (state.room) {
      details = {
        name: state.room.infos.name,
        language: state.room.infos.language,
        device: state.room.infos.device,
        browser: state.room.infos.browser,
        active_since: state.room.infos.active_since,
        origin: state.room.infos.origin,
        skill: state.room.infos.skill,
        extra: state.room.infos.extra,
        phone_number: state.room.infos.phone_number,
        satisfaction: state.room.infos.satisfaction
      }
    }
    return details
  },
  getZencallSkills () {
    return state.zencallSkills
  },
  isRoomLoading () {
    return state.isRoomLoading
  }
}

// actions
const actions = {
  sendBlockRoom () {
    this._vm.$socket.send({
      cmd: 'block_room',
      room: state.room.uuid
    })
  },
  // eslint-disable-next-line
  sendCloseRoom () {
    this._vm.$socket.send({
      cmd: 'close_room',
      room: state.room.uuid
    })
  },
  // eslint-disable-next-line
  sendFiles ({ }, data) {
    const response = data.response
    const uploadFile = data.uploadFile
    this._vm.$socket.send({
      cmd: 'send_message',
      room: state.room.uuid,
      content: {
        url: response.data.file,
        txt: uploadFile.name,
        mimetype: uploadFile.type
      },
      rich_content: [{
        kind: 'file',
        file: {
          url: response.data.file,
          name: uploadFile.name,
          mimetype: uploadFile.type
        }
      }]
    })
  },
  // eslint-disable-next-line
  sendLaunchZenCall ({ }, skill_uuid) {
    this._vm.$socket.send({
      cmd: 'launch_zencall',
      room: state.room.uuid,
      zencall: skill_uuid
    })
  },
  // eslint-disable-next-line
  sendLocations ({ }, places) {
    let content = ''
    const richContent = []
    places.forEach((place) => {
      richContent.push(place)
      content += place.location.label + '\n'
    })

    this._vm.$socket.send({
      cmd: 'send_message',
      rich_content: richContent,
      content: content,
      room: state.room.uuid
    })
  },
  // eslint-disable-next-line
  sendRoom ({ }, route) {
    this._vm.$socket.send({
      cmd: 'get_room',
      uuid: route.params.uuid
    })
    let fromevent = null
    if (route.params.event_uuid) {
      fromevent = route.params.event_uuid
    }
    this._vm.$socket.send({
      cmd: 'get_messages',
      room: route.params.uuid,
      lastevent: null,
      fromevent: fromevent
    })
    this._vm.$socket.send({
      cmd: 'get_history',
      room: route.params.uuid
    })
  },
  sendRoomsList () {
    // console.log('VUE', Vue, 'RWS', )
    this._vm.$socket.send({
      cmd: 'get_rooms'
    })
  },
  initRoomsTimes ({ commit, state }) {
    if (state.areTimersStarted === false) {
      window.setInterval(() => {
        commit('updateRoomsTimes')
      }, 1000)
    }
    commit('initTimersStarted')
  },
  sendRoomUnreadMsgs ({ commit, state }, uuid) {
    let status
    for (const prop in state.list) {
      if (state.list[prop].data instanceof Array) {
        state.list[prop].data.forEach((room) => {
          if (room.uuid === uuid) {
            status = room.status
            commit('updateRoomAsRead', room)
          }
        })
      } else {
        for (const skill in state.list[prop].data) {
          state.list[prop].data[skill].data.forEach((room) => {
            if (room.uuid === uuid) {
              status = room.status
              commit('updateRoomAsRead', room)
            }
          })
        }
      }
    }
    if (['late', 'running'].indexOf(status) > -1) {
      this._vm.$socket.send({
        cmd: 'room_is_read',
        room: uuid
      })
    }
  },
  // eslint-disable-next-line
  sendTransferRoom ({ }, skillUuid) {
    this._vm.$socket.send({
      cmd: 'transfer_room',
      room: state.room.uuid,
      skill: skillUuid
    })
  },
  sendZencallSkills () {
    this._vm.$socket.send({
      cmd: 'get_zencalls'
    })
  }
}

// mutations
const mutations = {
  initRoomHistory (state, data) {
    // console.log('HISTORY', data.data)
    state.history = data.history
    state.isRoomLoading = false
  },
  initTimersStarted (state) {
    state.areTimersStarted = true
  },
  setRoomIsLoading (state) {
    state.isRoomLoading = true
    state.messages = null
    state.room = null
    state.history = null
  },
  updateAccordion (state, status) {
    for (const status_ in state.list) {
      if (status === status_) {
        state.list[status_].expanded = !state.list[status_].expanded
      }
    }
  },
  updateList (state, data) {
    const list = {}
    let count = 0
    data.data.forEach((room) => {
      if (room.status !== 'blocked') {
        const value = _getListTime(state.startTime, room)
        room = Object.assign({}, room, {
          list_time: value
        })
        if (['late', 'running'].indexOf(room.status) > -1) {
          count++
        }
        // console.log('ROOM.STATUS IN LIST', room.status in list)
        if (['waiting', 'transferred'].indexOf(room.status) > -1) {
          if ('waiting' in list) {
            // there's already a "waiting" section, check if there's a
            // skill subsection within.
            if (room.infos.skill in list.waiting) {
              // The room subsection exists
              this._vm.$set(
                list.waiting[room.infos.skill].data,
                list.waiting[room.infos.skill].data.length,
                room)
            } else {
              // The skill subsection doesn't exist
              const skillData = list.waiting
              skillData[room.infos.skill] = {
                data: [room]
              }
              this._vm.$set(list, 'waiting', skillData)
            }
          } else {
            // No "waiting" in the rooms list, add it with the skill subsection
            const skillData = {}
            skillData[room.infos.skill] = {
              data: [room]
            }
            this._vm.$set(list, 'waiting', skillData)
          }
        } else {
          // Not waiting/transferred: display directy rooms.
          if (room.status in list) {
            this._vm.$set(
              list[room.status],
              list[room.status].length,
              room)
          } else {
            this._vm.$set(list, room.status, [room])
          }
        }
        // if (room.status in list) {
        //   if (['waiting', 'transferred'].indexOf(room.status) > -1) {
        //     console.log('#### WAITING', list['waiting'].data)
        //     const skill = room.infos.skill
        //     if (list['waiting'].data !== undefined && skill in list['waiting'].data) {
        //       this._vm.$set(list['waiting'].data[skill],
        //                     list['waiting'].data[skill].length,
        //                     room)
        //     } else {
        //       console.log('CASE NEW')
        //       let skillData = {
        //         data: {}
        //       }
        //       skillData['data'][skill] = {}
        //       this._vm.$set(list['waiting'], skillData, {
        //         expanded: false,
        //         data: [room]
        //       })
        //       console.log('DATA', list['waiting'])
        //     }
        //   } else {
        //     this._vm.$set(list[room.status],
        //                   list[room.status].length,
        //                   room)
        //   }
        // } else {
        //   if (['waiting', 'transferred'].indexOf(room.status) > -1) {
        //     const skill = room.infos.skill
        //     let skillRooms = {}
        //     skillRooms[skill] = {
        //       expanded: false,
        //       data: [room]
        //     }
        //     this._vm.$set(list, 'waiting', skillRooms)
        //   } else {
        //     this._vm.$set(list, room.status, [room])
        //   }
        //   // this._vm.$set(list, room.status, [room])
        // }
      }
    })
    const availableStatus = ['running', 'late', 'waiting', 'closed']
    const sortedList = {}
    availableStatus.forEach(status => {
      if (status in list) {
        let expanded = false
        if (state.list && status in state.list) {
          // console.log('STATUS', status, 'EXPANDED', state.list[status].expanded)
          expanded = state.list[status].expanded
        }
        sortedList[status] = {
          expanded: expanded,
          data: list[status]
        }
      }
    })
    state.list = Object.assign({}, sortedList)
    state.openRoomsCount = count
    state.areRoomsLoading = false
  },
  updateRoom (state, data) {
    state.room = Object.assign({}, state.room, data.data)
    state.isRoomLoading = false
    let roomStatus = state.room.status
    if (roomStatus === 'transferred') {
      roomStatus = 'waiting'
    }
    for (const status in state.list) {
      if (status === roomStatus) {
        state.list[status].expanded = true
      }
    }
  },
  updateRoomAsRead (state, room) {
    room.unread_msg = 0
  },
  updateRoomHistory (state, data) {
    state.history = data.data
    state.isRoomLoading = false
  },
  updateRoomMessages (state, data) {
    state.messages = data.messages
    state.isRoomLoading = false
  },
  updateRoomNotes (state, data) {
    state.notes = data.data
    state.isRoomLoading = false
  },
  updateRoomEvent (state, data) {
    // console.log('EVENTS', data.data)
    // TODO:
    // - Also for rooms status changes
    // - Messages should not be push at end but after the last message with
    // created < to data.data.created
    state.isRoomLoading = false
    // console.log('ROOM EVENT', data.data.room, state.room.uuid)
    if (state.room && data.data.room === state.room.uuid) {
      if (data.data.rich_content !== null) {
        state.messages.push(data.data)
      }
      this._vm.$set(state.room, 'status', data.data.kind)
    }
  },
  updateRoomsTimes (state, data) {
    if (data !== undefined && data.staticTime !== undefined &&
        data.staticTime === true) {
      const settings = this._vm.$settings
      for (const prop in state.list) {
        if (state.list[prop].data instanceof Array) {
          state.list[prop].data.forEach((room) => {
            room.list_time = _getListStaticTime(room, settings)
          })
        } else {
          for (const skill in state.list[prop].data) {
            state.list[prop].data[skill].data.forEach((room) => {
              room.list_time = _getListStaticTime(room, settings)
            })
          }
        }
      }
    } else {
      state.startTime = state.startTime + 1000
      for (const prop in state.list) {
        if (state.list[prop].data instanceof Array) {
          state.list[prop].data.forEach((room) => {
            room.list_time = _getListTime(state.startTime, room)
          })
        } else {
          for (const skill in state.list[prop].data) {
            state.list[prop].data[skill].data.forEach((room) => {
              room.list_time = _getListTime(state.startTime, room)
            })
          }
        }
      }
    }
  },
  updateZencallSkills (state, data) {
    state.zencallSkills = data.data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
